export default {"src":"/pro/_next/static/media/usdb.e240f424.svg","height":140,"width":140,"blurWidth":0,"blurHeight":0};